import { Result, Button, Image } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MarshmallowSuccess = () => {
  const n = useNavigate();
  const pics = [
    '1720886117738%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2060.jpg',
    '1720886129765%C3%A7%C2%8B%C2%90%C3%A7%C2%8B%C2%90%2051.JPG',
    '1721027713961false-3.png',
    '1721027861132false-10.png',
    'b3db9797ee238ee205333508fcaf33bb-1734105927.jpg',
  ];
  const [selectPic, setSelectPic] = useState('');
  useEffect(() => {
    setSelectPic(pics[Math.floor(Math.random() * pics.length)]);
  }, []);
  return (
    <Result
      status='success'
      title='投递成功！'
      subTitle={
        <>
          <div>感谢小狐凃的投稿~！</div>
          <Image
            width={150}
            height={150}
            src={`https://nekoda.cn/usr/uploads/` + selectPic}
          />
        </>
      }
      extra={[
        <Button type='primary' onClick={() => n('/marshmallow')}>
          返回棉花糖
        </Button>,
      ]}
    />
  );
};

export default MarshmallowSuccess;
